import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../../services/default/auth.service';
import { MixpanelService } from '../../services/mixpanel.service';

@Component({
  selector: 'app-user-actions',
  templateUrl: './user-actions.component.html',
  styleUrls: ['./user-actions.component.scss'],
})
export class UserActionsComponent implements OnInit {
  form: UntypedFormGroup;
  sending = false;
  user$ = false;
  initialsName = '';

  menuList = {
    '1_Comprar': [
      {
        text: 'Favoritos',
        link: '/leilao/lotes-favoritos',
        icon: '#ic-heart',
      },
      {
        text: 'Meus lances',
        link: '/leilao/lotes-lances',
        icon: '#ic-myProposals',
      },
      {
        text: 'Lotes ganhos',
        link: '/lotes-ganhos',
        icon: '#ic-price',
      },
    ],
    '2_Vender': [
      {
        text: 'Quero vender',
        link: '/lote/cadastrar',
        icon: '#ic-moneyGraph',
      },
      {
        text: 'Meus lotes',
        link: '/lotes-em-leilao',
        icon: '#ic-hammer',
      },
      {
        text: 'Lotes vendidos',
        link: '/lotes-vendidos',
        icon: '#ic-handshake',
      },
    ],
    '3_Gerenciar': [
      {
        text: 'Meu cadastro',
        link: '/perfil',
        icon: '#ic-myProfile',
      },
      {
        text: 'Alterar e-mail',
        link: '/perfil/alterar-email',
        icon: '#ic-email-simbol',
      },
      {
        text: 'Alterar senha',
        link: '/perfil/alterar-senha',
        icon: '#ic-secure-key',
      },
    ],
  };

  constructor(private fb: UntypedFormBuilder, private auth: AuthService, private router: Router, private mixpanel: MixpanelService) { }

  ngOnInit(): void {
    this.createForm();
    this.auth.user$.subscribe((user: any) => {
      if (user.userLoginInfo) {
        const firstNameChar = user.userLoginInfo.firstName ? user.userLoginInfo.firstName.substr(0, 1) : '';
        const lastNameChar = user.userLoginInfo.lastName ? user.userLoginInfo.lastName.split(/\s/).pop().substr(0, 1) : '';
        this.initialsName = (firstNameChar + lastNameChar).toUpperCase();
      }
      this.user$ = user;
    }
    );
  }

  createForm() {
    this.form = this.fb.group({ search: ['', []] });
  }

  logout() {
    this.initialsName = '';
    this.auth.logout();
    return this.router.navigate(['/']);
  }

  goToLogin() {
    this.mixpanel.track('Botão | Favoritos', {
      item: 'Favoritos',
      rota: '/leilao/lotes-favoritos'
    });

    if (this.user$) {
      this.router.navigate(['/leilao/lotes-favoritos']);
    } else {
      this.router.navigate(['/login']);
    }
  }

  onMenuClick(item: any): void {
    this.mixpanel.track(`Menu Usuário | ${item.text}`, {
      item: item.text,
      rota: item.link
    });

    this.router.navigate([item.link]);
  }
}
